/* eslint-disable */

export default `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=windows-1252"/>
	<title></title>
	<meta name="generator" content="LibreOffice 7.1.2.2 (Windows)"/>
	<meta name="created" content="2022-01-03T18:54:00"/>
	<meta name="changed" content="2022-01-05T20:36:18.739000000"/>
	<meta name="AppVersion" content="16.0000"/>
	<style type="text/css">
		@page { size: 21cm 29.7cm; margin-left: 3.25cm; margin-right: 3cm; margin-top: 1.25cm; margin-bottom: 2.5cm }
		p { margin-bottom: 0.25cm; direction: ltr; line-height: 80%; text-align: left; orphans: 2; widows: 2; background: transparent }
		a:link { color: #0000ff; text-decoration: underline }
		a:visited { color: #800000; so-language: zxx; text-decoration: underline }
	</style>
</head>
<body lang="pt-BR" link="#0000ff" vlink="#800000" dir="ltr">
<div title="header"><p align="center" style="margin-bottom: 1.15cm; border: none; padding: 0cm; line-height: 100%">
	<br/>

	</p>
</div><p align="center" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; display: flex; justify-content: center">
<font size="3" style="font-size: 12pt"><span style="font-variant: small-caps"><font face="Tahoma, serif"><u><b>COMO FUNCIONA ESTA PLATAFORMA</b></u></font></span></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Fizemos
o m&aacute;ximo para reduzir e simplificar as regras da nossa
Plataforma. Por isso, separamos abaixo os pontos mais importantes
para voc&ecirc;, que tamb&eacute;m podem ser lidos de forma bem
completa e detalhada nos </font><font face="Tahoma, serif"><u><b>Termos
de Uso a seguir</b></u></font><font face="Tahoma, serif">. 	</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Al&eacute;m
disso, estamos sempre dispon&iacute;veis para tirar qualquer d&uacute;vida
que voc&ecirc; tenha pelo e-mail contato@synsaude.com.br e pelo nosso WhatsApp (98) 99229-
3099 disponibilizado na plataforma.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>1)
O que fazemos?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	Nosso
neg&oacute;cio &eacute; uma Plataforma de Marketplace que possibilita</font><font face="Tahoma, serif">
que o 	m&eacute;dico, ao constatar que o paciente atendido por ele
necessita de uma 	cirurgia, solicite um or&ccedil;amento para o
paciente, </font><font face="Tahoma, serif">de acordo com suas
	necessidades espec&iacute;ficas,</font><font face="Tahoma, serif">
aos hospitais e fornecedores de OPME 	parceiros da plataforma.</font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	Ap&oacute;s
a solicita&ccedil;&atilde;o do m&eacute;dico, todos os parceiros
envolvidos s&atilde;o 	notificados em tempo real e de forma
instant&acirc;nea poder&atilde;o acessar a 	plataforma, avaliar a
solicita&ccedil;&atilde;o e responder ao or&ccedil;amento que foi
	solicitado pelo m&eacute;dico.</font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	A
Plataforma re&uacute;ne e faz a curadoria das informa&ccedil;&otilde;es</font><font face="Tahoma, serif">
enviadas pelos 	parceiros </font><font face="Tahoma, serif">e realiza
um or&ccedil;amento &uacute;nico, com todos os custos 	envolvidos no
procedimento j&aacute; calculados e precificados, sem custos
	adicionais. Com isso, o paciente pode escolher o or&ccedil;amento
que deseja 	e agendar o procedimento com seguran&ccedil;a.</font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	Al&eacute;m
disso, o m&eacute;dico pode criar, previamente, v&aacute;rios pacotes
cir&uacute;rgicos 	de acordo com a sua demanda e prefer&ecirc;ncia
atrav&eacute;s da plataforma.</font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u>N&oacute;s
</u></font><font face="Tahoma, serif"><u><b>n&atilde;o</b></u></font><font face="Tahoma, serif"><u>
somos fornecedores de servi&ccedil;os anunciados na plataforma, n&atilde;o
realizamos cirurgias e procedimentos e nem nos responsabilizamos pelas a&ccedil;&otilde;es
dos Usu&aacute;rios que anunciam e compram por meio da </u></font><font face="Tahoma, serif"><u><b>Syn</b></u></font><font face="Tahoma, serif"><u>.
Somos apenas uma plataforma de tecnologia que realiza a intermedia&ccedil;&atilde;o
online de vendas.</u></font><font face="Tahoma, serif"><u><b> </b></u></font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>2)
</b></u></font><font face="Tahoma, serif"><u><b>O uso da nossa
Plataforma &eacute; pago?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	Todos os Usu&aacute;rios poder&atilde;o ter acesso e navegar, de maneira gratuita, &agrave;s
funcionalidades da plataforma. Contudo, os servi&ccedil;os da plataforma s&atilde;o pagos no
caso de procedimentos contratados e os pagamentos podem ser realizados
diretamente pela plataforma.</font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">

</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>3)
&Eacute; seguro usar a nossa Plataforma?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Nos esfor&ccedil;amos bastante para que a nossa plataforma seja segura e n&atilde;o ser&atilde;o
usadas sem o consentimento do Usu&aacute;rio, mas ainda assim recomendamos que,
antes de baixar qualquer conte&uacute;do, voc&ecirc; instale antiv&iacute;rus e programas de
prote&ccedil;&atilde;o.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>4)
Estas condi&ccedil;&otilde;es podem ser alteradas?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Nossos
Termos de Uso poder&atilde;o mudar, mas voc&ecirc; sempre poder&aacute;
acessar a vers&atilde;o mais atualizada na nossa Plataforma. Al&eacute;m
disso, se formos realizar alguma a&ccedil;&atilde;o que a lei exija
sua autoriza&ccedil;&atilde;o, voc&ecirc; receber&aacute; um aviso
antes para poder aceitar ou recusar.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>5)
O que acontece com os dados pessoais?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Temos
uma Pol&iacute;tica de Privacidade que trata sobre o que fazemos com
os seus dados pessoais. &Eacute; muito importante que voc&ecirc; leia
e entenda esse documento tamb&eacute;m! </font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>6)
Qual &eacute; o conte&uacute;do dos Termos de Uso?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Os
Termos de Uso a seguir est&atilde;o divididos da seguinte forma para
facilitar o seu acesso &agrave; informa&ccedil;&atilde;o:</font></font></p>
<ol type="a">
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">a)
	</font><font face="Tahoma, serif">Data de Disponibiliza&ccedil;&atilde;o
	do Texto;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">b)
	</font><font face="Tahoma, serif">Explica&ccedil;&atilde;o dos
	Termos T&eacute;cnicos ou em L&iacute;ngua Estrangeira;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">c)
	</font><font face="Tahoma, serif">Servi&ccedil;os;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">d)
	</font><font face="Tahoma, serif">Cadastro dos Usu&aacute;rios;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">e)
	</font><font face="Tahoma, serif">Pagamento pelo Uso da Plataforma;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">f)
	</font><font face="Tahoma, serif">Reembolso e Cancelamento pelo Usu&aacute;rio;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">g)
	</font><font face="Tahoma, serif">Responsabilidades das Partes;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">h)
	</font><font face="Tahoma, serif">Isen&ccedil;&atilde;o de
	Responsabilidade da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">i)
	</font><font face="Tahoma, serif">Regras de Conduta e Proibi&ccedil;&otilde;es;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">j)
	</font><font face="Tahoma, serif">Propriedade Intelectual</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">k)
	</font><font face="Tahoma, serif">Sigilo e Confidencialidade;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">l)
	</font><font face="Tahoma, serif">Tratamento de Dados Pessoais,
	Privacidade e Seguran&ccedil;a;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">m)
	</font><font face="Tahoma, serif">Desdobramentos do Acesso &agrave;
	Plataforma;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">n)</font><font face="Tahoma, serif">
	Altera&ccedil;&otilde;es dos Termos e Condi&ccedil;&otilde;es de
	Uso;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">o)
	</font><font face="Tahoma, serif">Defini&ccedil;&atilde;o da Lei
	Aplic&aacute;vel e do Foro de Elei&ccedil;&atilde;o;</font></font></p>
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%"><font size="3" style="font-size: 12pt"><font face="Tahoma, serif">p)
	</font><font face="Tahoma, serif">Canal de Contato.</font></font></p>
</ol>

<p align="right" style="margin-left: 1.27cm; margin-top: 0.1cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><b>Syn.</b></font></font></p>

<p align="center" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; display: flex; justify-content: center">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>TERMOS
DE USO </b></u></font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff"><a name="_heading=h.gjdgxs"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Esta
Plataforma, cujo nome &eacute; </font><font face="Tahoma, serif"><b>Syn Sa&uacute;de</b></font><font face="Tahoma, serif">
&eacute; de propriedade, mantida e operada por </font><font face="Tahoma, serif"><b>SYN
SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE LTDA,</b></font><font face="Tahoma, serif">
pessoa jur&iacute;dica de direito privado inscrita no CNPJ/ME sob o
n&ordm; 38.312.622/0001-28, com sede na Rua
Miquerinos, 01, Bairro Jardim Renascen&ccedil;a, Edif&iacute;cio Golden Tower, Sala 906, S&atilde;o
Lu&iacute;s, Maranh&atilde;o, CEP: 65.075-038.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Estes termos de uso s&atilde;o referentes ao Usu&aacute;rio M&eacute;dico, Usu&aacute;rio Secret&aacute;ria,
Usu&aacute;rio Hospital, Usu&aacute;rio Fornecedor de OPME, Usu&aacute;rio Operacional e Usu&aacute;rio
Cliente.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>Este
documento visa prestar informa&ccedil;&otilde;es sobre o modo de
utiliza&ccedil;&atilde;o da Plataforma pelos Usu&aacute;rios e suas
ferramentas, condi&ccedil;&otilde;es, nomenclaturas, direitos e
deveres.</b></u></font><font face="Tahoma, serif">
Alertamos que todo o texto deve ser lido
com aten&ccedil;&atilde;o e, caso voc&ecirc; n&atilde;o concorde com o conte&uacute;do de nossos termos e/ou
pol&iacute;tica de privacidade, n&atilde;o d&ecirc; prosseguimento &agrave; navega&ccedil;&atilde;o ou a utiliza&ccedil;&atilde;o de
nossos servi&ccedil;os. Recomendamos, ainda, que caso seja aceito, que voc&ecirc;
armazene ou imprima uma c&oacute;pia deste contrato, incluindo todas as pol&iacute;ticas.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>1.
DATA DE DISPONIBILIZA&Ccedil;&Atilde;O DO TEXTO</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">1.1.
A presente vers&atilde;o deste documento foi disponibilizada em:
29/11/2022.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><span style="font-variant: small-caps"><font face="Tahoma, serif"><u><b>2.
EXPLICA&Ccedil;&Atilde;O DOS TERMOS T&Eacute;CNICOS OU EM L&Iacute;NGUA
ESTRANGEIRA</b></u></font></span></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">2.1.
Abaixo est&atilde;o dispostos os significados das nomenclaturas
t&eacute;cnicas e termos na l&iacute;ngua inglesa.</font></font></p>
<ul style="font-size: 12pt">

	<li >
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Login:
	&Eacute; o processo que permite o acesso a um sistema inform&aacute;tico,
	controlado por meio de identifica&ccedil;&atilde;o e autentica&ccedil;&atilde;o
	do Usu&aacute;rio pelas credenciais fornecidas por esse mesmo
	internauta.
  </font></font>
  </p>

	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Online:
	Termo da l&iacute;ngua inglesa cujo significado literal &eacute; &ldquo;em
	linha&rdquo;. &Eacute; habitualmente usado para designar que um
	determinado Usu&aacute;rio da internet ou de outra rede de
	computadores est&aacute; conectado &agrave; rede.</font></font></p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">V&iacute;rus:
	Software malicioso que infecta sistemas e computadores, com objetivo
	de causar algum dano, faz c&oacute;pias de si mesmo e tenta se
	espalhar para outros computadores, utilizando-se de diversos meios.</font></font></p>
</ul>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">2.2.
S&atilde;o os tipos de Usu&aacute;rios da Plataforma:</font></font></p>
<ul style="font-size: 12pt">
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	M&eacute;dico: Aquele que cria pacotes cir&uacute;rgicos, solicita
	cirurgias, aprova propostas, acompanha o status de suas solicita&ccedil;&otilde;es
	de cirurgias, compartilha pacotes de cirurgias com colegas e
	hospitais e convida outros m&eacute;dicos para serem parceiros da
	SYN.</font></font></p>

	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio Secret&aacute;ria: Aquele que tem autoriza&ccedil;&atilde;o de um (ou mais de
		um) Usu&aacute;rio M&eacute;dico para ter acesso &agrave;s mesmas informa&ccedil;&otilde;es que esse
		Usu&aacute;rio tem, podendo criar, editar e acompanhar procedimentos. Por&eacute;m,
		este Usu&aacute;rio n&atilde;o pode aprovar propostas ou excluir solicita&ccedil;&otilde;es.</font></font></p>

	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	Hospital: Aquele que responde a solicita&ccedil;&atilde;o de cota&ccedil;&atilde;o
	de cirurgias, avalia&ccedil;&atilde;o pr&eacute;-anest&eacute;sica,
	banco de sangue e que possui a op&ccedil;&atilde;o de recusar
	solicita&ccedil;&atilde;o de or&ccedil;amento. </font></font>
	</p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	Fornecedor de OPME: Aquele que responde a solicita&ccedil;&atilde;o
	de cota&ccedil;&atilde;o de &Oacute;rtese, Pr&oacute;tese e
	Materiais Especiais (OPME) feita pelo Usu&aacute;rio M&eacute;dico.</font></font></p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	Cliente: Aquele que recebe as propostas de or&ccedil;amentos
	solicitadas pelo usu&aacute;rio m&eacute;dico, acompanha os status
	da solicita&ccedil;&atilde;o e aprova ou reprova a(s) proposta(s) e realiza pagamentos.</font><font color="#d99594"><font face="Tahoma, serif">.</font></font></font></p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Estes
	Usu&aacute;rios, em conjunto, ser&atilde;o chamados apenas de
	Usu&aacute;rios.</font></font></p>
</ul>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>3.
SERVI&Ccedil;OS</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff"><a name="_heading=h.30j0zll"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.1.
</font><font face="Tahoma, serif"><u><b>O que somos:</b></u></font><font face="Tahoma, serif">
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">consiste,
mas n&atilde;o se limita, a uma Plataforma de Marketplace que
possibilita</font><font face="Tahoma, serif"> que o m&eacute;dico, ao
constatar que o paciente atendido por ele necessita de uma cirurgia e
n&atilde;o possui plano de sa&uacute;de, solicite um or&ccedil;amento
para o paciente, </font><font face="Tahoma, serif">de acordo com suas
necessidades espec&iacute;ficas,</font><font face="Tahoma, serif">
aos hospitais e fornecedores de OPME parceiros da plataforma.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.2. Ap&oacute;s
a solicita&ccedil;&atilde;o do m&eacute;dico, todos os parceiros
envolvidos s&atilde;o notificados em tempo real e de forma
instant&acirc;nea poder&atilde;o acessar a plataforma, avaliar a
solicita&ccedil;&atilde;o e responder ao or&ccedil;amento que foi
solicitado pelo m&eacute;dico.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.3. A Plataforma re&uacute;ne e faz a curadoria das informa&ccedil;&otilde;es enviadas pelos parceiros e realiza um or&ccedil;amento &uacute;nico, com todos os custos envolvidos no procedimento j&aacute; calculados e precificados, sem custos adicionais, contemplados na solicita&ccedil;&atilde;o do usu&aacute;rio m&eacute;dico. Com isso, o paciente pode escolher a proposta que deseja e agendar o procedimento com seguran&ccedil;a.</font></font></p>
<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u>3.3.1.
</u></font><font face="Tahoma, serif"><u>Os custos apresentados se referem &agrave;queles repassados pelo
Usu&aacute;rio M&eacute;dico em sua solicita&ccedil;&atilde;o. Eventualmente, outros custos podem
ser apresentados pelo Usu&aacute;rio fornecedor do produto ou servi&ccedil;o. Tais
custos ser&atilde;o repassados ao Usu&aacute;rio Cliente, sendo que a Syn n&atilde;o se
responsabiliza por tais custos.</u></font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
3.4. Al&eacute;m disso, o m&eacute;dico pode criar, previamente, v&aacute;rios pacotes cir&uacute;rgicos de
acordo com a sua demanda e prefer&ecirc;ncia atrav&eacute;s da plataforma.</font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u>
3.5. A <b>Syn</b> n&atilde;o &eacute; fornecedora de servi&ccedil;os anunciados na plataforma, n&atilde;o realiza
cirurgias e procedimentos e nem se responsabiliza pelas a&ccedil;&otilde;es dos Usu&aacute;rios que
anunciam e compram por meio da <b>Syn</b>. A <b>Syn</b> &eacute; apenas uma plataforma de
tecnologia que realiza a intermedia&ccedil;&atilde;o online de vendas.</u>
</font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.6.
Ao utilizar a </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">,
o Usu&aacute;rio deve compreender e aceitar que todas as suas a&ccedil;&otilde;es
e escolhas s&atilde;o livres e n&atilde;o possuem nenhum tipo de
influ&ecirc;ncia ou inger&ecirc;ncia da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.7.
Fica esclarecido que o presente servi&ccedil;o n&atilde;o estabelece entre as partes
qualquer v&iacute;nculo empregat&iacute;cio, societ&aacute;rio ou associativo, permanecendo cada
parte como &uacute;nica respons&aacute;vel por todas as suas respectivas despesas e encargos,
sejam de natureza trabalhista, previdenci&aacute;ria, fiscal, securit&aacute;ria, civil, penal ou
de qualquer outra natureza ou esp&eacute;cie.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.8.
O Usu&aacute;rio M&eacute;dico &eacute; o &uacute;nico respons&aacute;vel
perante seu conselho de classe, n&atilde;o cabendo a </font><font face="Tahoma, serif"><b>Syn
</b></font><font face="Tahoma, serif">qualquer imputa&ccedil;&atilde;o
de responsabilidade por qualquer a&ccedil;&atilde;o ou omiss&atilde;o
perante o conselho de classe. </font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>4.
CADASTRO DOS USU&Aacute;RIOS</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.3znysh7"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.
Para o cadastro e utiliza&ccedil;&atilde;o dos servi&ccedil;os da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif"><b>
</b></font><font face="Tahoma, serif">ser&atilde;o requeridas as
seguintes informa&ccedil;&otilde;es:</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.1.
Usu&aacute;rio M&eacute;dico: Nome completo, CPF, data de nascimento,
e-mail, telefone, CRM/CRO, UF, especialidade(s), dados banc&aacute;rios.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.94fvkp2ixaux"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.2.
Usu&aacute;rio Secret&aacute;ria: Nome completo, CPF, e-mail e telefone. </font></font>
</p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.94fvkp2ixaux"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.3. Usu&aacute;rio Hospital: Nome fantasia, Raz&atilde;o social, CNPJ, UF, Taxa de
comercializa&ccedil;&atilde;o de OPME (caso haja), setor, dados banc&aacute;rios, dados do
usu&aacute;rio respons&aacute;vel pelas cota&ccedil;&otilde;es como: Nome completo, CPF, cargo,
e-mail e telefone com WhatsApp. </font></font>
</p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.ct0qaac8v5e0"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.4.
Usu&aacute;rio Fornecedor de OPME: Nome fantasia, Raz&atilde;o social, CNPJ,
nome do respons&aacute;vel, CPF, telefone e e-mail do respons&aacute;vel,
especialidades que fornecem materiais, dados banc&aacute;rios.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.3n1jcbbhja3t"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.5.
Usu&aacute;rio Operacional: Nome completo, CPF, telefone, data de
nascimento, e-mail</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.3n1jcbbhja3t"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.1.6.
Usu&aacute;rio Paciente: Nome completo, CPF, data de nascimento, e-
mail, comorbidade e dados banc&aacute;rios.</font></font></p>

<p align="justify" style="margin-bottom: 0cm; line-height: 80%"><a name="_heading=h.kz97zzxxhx3y"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.2.
No caso de Usu&aacute;rio Cliente, o cadastro ser&aacute; realizado pelo Usu&aacute;rio M&eacute;dico
respons&aacute;vel que ir&aacute; fornecer a plataforma: Nome completo, CPF, data de
nascimento, e-mail e comorbidade. Quando um Usu&aacute;rio M&eacute;dico solicita uma
cirurgia vinculada ao n&uacute;mero de CPF do Usu&aacute;rio Cliente, este poder&aacute; acessar a
plataforma com seu CPF e definir senha no primeiro acesso. O Usu&aacute;rio M&eacute;dico
est&aacute; ciente de que deve ter autoriza&ccedil;&atilde;o do Usu&aacute;rio Cliente sobre o cadastro,
antes de efetu&aacute;-lo.</font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u>4.2.1.
</u></font><font face="Tahoma, serif"><u>&Eacute; permitida a realiza&ccedil;&atilde;o de apenas 1 (uma) conta por CPF,
contudo, o Usu&aacute;rio poder&aacute; ter mais de um perfil sendo que esse pode
ser, por exemplo, Paciente e ao mesmo tempo Secret&aacute;ria.</u></font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-bottom: 0cm; line-height: 80%"><a name="_heading=h.wrfhu32tibkn"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.3.
Cada Usu&aacute;rio determinar&aacute; o seu </font><font face="Tahoma, serif"><i>login</i></font><font face="Tahoma, serif">
e senha de acesso, sendo de sua exclusiva responsabilidade a
manuten&ccedil;&atilde;o do sigilo dessas informa&ccedil;&otilde;es.
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">n&atilde;o
se responsabiliza pelas a&ccedil;&otilde;es e danos que poder&atilde;o
ser causados pelo acesso irregular da conta de acesso por terceiros.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.4.
</font><font face="Tahoma, serif">O cadastro para Usu&aacute;rio Paciente na plataforma &eacute; permitido a crian&ccedil;as e
idosos acima de 70 (setenta) anos, desde que comprovadamente com
respons&aacute;vel legal e a <b>Syn</b> far&aacute; esfor&ccedil;os razo&aacute;veis para confirmar esse dado, mas
n&atilde;o se responsabiliza caso a pessoa cadastrada n&atilde;o possua a idade m&iacute;nima aqui
descrita. </font></font>
</p>
<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.4.1.
</font><font face="Tahoma, serif">Para os demais cadastros na plataforma &eacute; permitido somente a
pessoas acima de 18 (dezoito) anos e a Syn far&aacute; esfor&ccedil;os razo&aacute;veis para
confirmar esse dado, mas n&atilde;o se responsabiliza caso a pessoa
cadastrada n&atilde;o possua a idade m&iacute;nima aqui descrita.</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.5.
 Os Usu&aacute;rios s&atilde;o respons&aacute;veis por fornecer
informa&ccedil;&otilde;es verdadeiras, precisas e atualizadas.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">4.6.
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">poder&aacute;
recusar, suspender ou cancelar sem notifica&ccedil;&atilde;o pr&eacute;via
a conta de acesso de um Usu&aacute;rio sempre que suspeitar que as
informa&ccedil;&otilde;es fornecidas s&atilde;o falsas, incompletas,
desatualizadas ou imprecisas ou, ainda, nos casos indicados nas leis
e regulamentos aplic&aacute;veis, nestes Termos de Uso ou em qualquer
Pol&iacute;tica.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>5.
PAGAMENTO PELO USO DA PLATAFORMA</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">5.1.
Todos os Usu&aacute;rios poder&atilde;o ter acesso, de maneira
gratuita, &agrave;s funcionalidades da plataforma.</font><font face="Tahoma, serif">
</font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">5.2.
O Usu&aacute;rio Cliente pagar&aacute; uma taxa &agrave; plataforma
somente caso o procedimento seja contratado.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">5.3.</font><font face="Tahoma, serif"> Os procedimentos poderão ser pagos diretamente pela plataforma.
</font></font></p>
<p align="justify" style="margin-left: 1.5cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font face="Tahoma, serif"><font size="3" style="font-size: 12pt">5.3.1. &Eacute; poss&iacute;vel que o Usu&aacute;rio Cliente veja as propostas que est&atilde;o
aguardando aprova&ccedil;&atilde;o e fa&ccedil;a a aprova&ccedil;&atilde;o de propostas. </font></font></p>

<p align="justify" style="margin-left: 1.5cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font face="Tahoma, serif"><font size="3" style="font-size: 12pt">5.3.2.No momento em que o Usu&aacute;rio Cliente aprovar uma proposta, ele
ser&aacute; redirecionado para o pagamento, quando ir&aacute; verificar o resumo da
contrata&ccedil;&atilde;o e, em sequ&ecirc;ncia, precisar&aacute; informar os dados pessoais do
pagador e os dados de pagamento, momento em que informar&aacute; a forma,
se ser&aacute; por cart&atilde;o de cr&eacute;dito, pix, boleto ou m&uacute;ltiplas formas, que ser&aacute;
o fracionamento dos pagamentos entre as op&ccedil;&otilde;es citadas anteriormente.</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>6. REEMBOLSO E CANCELAMENTO PELO USU&Aacute;RIO</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">6.1. Direito de arrependimento: A Syn respeita todos os direitos de seus Usu&aacute;rios,
em especial o direito de arrependimento das compras feitas pela internet no
prazo de 07 (sete) dias, contados ap&oacute;s a contrata&ccedil;&atilde;o, desde que n&atilde;o tenha sido
realizado o procedimento, conforme disposto no C&oacute;digo de Defesa do
Consumidor. Ap&oacute;s a manifesta&ccedil;&atilde;o de arrependimento, ser&aacute; feito o reembolso de
todos os valores eventualmente pagos pelo Usu&aacute;rio.</font><font face="Tahoma, serif">
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">6.2. Para cancelar os servi&ccedil;os o Usu&aacute;rio dever&aacute; enviar um e-mail para
<a href="mailto:contato@synsaude.com.br"><font color="#1155cc"><font face="Tahoma, serif"><font size="3" style="font-size: 12pt"><u>contato@synsaude.com.br</u></font></font></font></a>. Caso j&aacute; tenha aprovado e realizado o pagamento de
alguma proposta, ser&aacute; retido, da restitui&ccedil;&atilde;o, um valor de 30% (trinta por cento)
sobre a taxa de servi&ccedil;os da plataforma. Ainda, dever&atilde;o ser observadas as regras
de cancelamento de cada Usu&aacute;rio Hospital.  </font><font face="Tahoma, serif">
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>7.
RESPONSABILIDADE DAS PARTES</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.1.</font><font face="Tahoma, serif"><b>
</b></font><font face="Tahoma, serif"><u><b>Responsabilidade da Syn:</b></u></font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.1.1.
Realizar os servi&ccedil;os conforme o descrito nestes termos de uso;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.1.2.
Responsabilizar-se pelo funcionamento da Plataforma e pelas corre&ccedil;&otilde;es
que eventualmente sejam necess&aacute;rias;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.1.3.
Informar altera&ccedil;&otilde;es de impacto significativo dos
servi&ccedil;os aos Usu&aacute;rios, por meio de comunicados simples
na Plataforma.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt">
<font face="Tahoma, serif">
7.2.
</font>
<font face="Tahoma, serif">
<b>
 </b>
</font>
<font face="Tahoma, serif">
<u>
<b>Responsabilidade do Usu&aacute;rio M&eacute;dico, Usu&aacute;rio Secret&aacute;ria, Usu&aacute;rio
Hospital, Usu&aacute;rio Fornecedor de OPME e Usu&aacute;rio Operacional:
</b>
</u>
</font>
</font>
</p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt">
<font face="Tahoma, serif">
7.2.1.
Utilizar a Plataforma conforme os crit&eacute;rios de utiliza&ccedil;&atilde;o
definidos pela
</font>
<font face="Tahoma, serif">
<b>Syn</b>
</font>
<font face="Tahoma, serif">,
sem alterar sua programa&ccedil;&atilde;o, quebrar senhas ou realizar
procedimentos que venham causar preju&iacute;zos a
</font>
<font face="Tahoma, serif">
<b>Syn</b>
</font>
<font face="Tahoma, serif">,
</font>
<font face="Tahoma, serif">
<b>
</b>
</font>
<font face="Tahoma, serif">
aos demais Usu&aacute;rios ou a
terceiros;
</font>
</font>
</p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt">
<font face="Tahoma, serif">
7.2.2.
Responsabilizar-se para todos os efeitos, inclusive jur&iacute;dicos,
pelo teor das informa&ccedil;&otilde;es que introduzir e pelos
compromissos que assumir na Plataforma;
</font>
</font>
</p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.2.3.
N&atilde;o adotar condutas inadequadas, ou praticar a&ccedil;&otilde;es
ou omiss&otilde;es contr&aacute;rias a estes Termos de Uso ou &agrave;s
Pol&iacute;ticas de Privacidade;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.2.4.
Responsabilizar-se pela indica&ccedil;&atilde;o de servi&ccedil;os
que n&atilde;o estejam vinculados a </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.2.5.
Respeitar integralmente estes Termos de Uso, Pol&iacute;ticas de
Privacidade, legisla&ccedil;&atilde;o vigente e eventuais contratos
entre as partes;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.2.6.
Estar em dia com as obriga&ccedil;&otilde;es junto ao seu conselho de
classe, se for o caso.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.2.7.
Zelar pelo bom atendimento ao Usu&aacute;rio Cliente; </font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.3.</font><font face="Tahoma, serif"><b>
</b></font><font face="Tahoma, serif"><u><b>Responsabilidade do
Usu&aacute;rio Cliente:</b></u></font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.3.1.
Utilizar a plataforma conforme os crit&eacute;rios de utiliza&ccedil;&atilde;o
definidos pela </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">,
sem alterar sua programa&ccedil;&atilde;o, quebrar senhas ou realizar
procedimentos que venham causar preju&iacute;zos a </font><font face="Tahoma, serif"><b>Syn,
</b></font><font face="Tahoma, serif">aos demais Usu&aacute;rios ou a
terceiros;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.3.2.
Responsabilizar-se para todos os efeitos, inclusive jur&iacute;dicos,
pelo teor das informa&ccedil;&otilde;es que introduzir, pelos
pagamentos das compras que realizar e por todos os compromissos que
assumir na plataforma;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.3.3.
Ler todas as informa&ccedil;&otilde;es sobre os servi&ccedil;os antes
de adquiri-los;</font></font></p>
<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.3.4.
Inserir dados verdadeiros, atualizados e completos para possibilitar
a efetiva&ccedil;&atilde;o dos pagamentos e entregas;</font></font></p>
<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">7.3.5.
Respeitar integralmente estes Termos de Uso, Pol&iacute;ticas de
Privacidade, legisla&ccedil;&atilde;o vigente e eventuais contratos
entre as partes.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>8.
ISEN&Ccedil;&Atilde;O DE RESPONSABILIDADE DA SYN</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.
</font><font face="Tahoma, serif"><u><b>A Syn</b></u></font><font face="Tahoma, serif"><u><b>
</b></u></font><font face="Tahoma, serif"><u><b>n&atilde;o se
responsabiliza por:</b></u></font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.1.
Eventual indisponibilidade da Plataforma, a qual n&atilde;o tenha
dado causa.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.2.
Condutas dos Usu&aacute;rios e pelo descumprimento de suas
obriga&ccedil;&otilde;es.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.3.
Inser&ccedil;&atilde;o de informa&ccedil;&otilde;es falsas pelos
Usu&aacute;rios.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.4.
Danos que o Usu&aacute;rio possa experimentar por a&ccedil;&otilde;es
exclusivas de terceiros, bem como falhas na conex&atilde;o de rede e
intera&ccedil;&otilde;es maliciosas como v&iacute;rus.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.5.
Danos que o Usu&aacute;rio possa ter em decorr&ecirc;ncia do mau uso
da Plataforma em desconformidade com estes Termos, com a Pol&iacute;tica
de Privacidade, com a lei ou ordens judiciais.</font></font></p>
<p align="justify" style="text-indent: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.6.
Casos fortuitos ou de for&ccedil;a maior.</font></font></p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.7. 
Procedimentos n&atilde;o realizados no prazo de at&eacute; 30 dias ap&oacute;s o
pagamento da proposta vencedora. Podendo o or&ccedil;amento ter seus
valores atualizados pelos parceiros (Hospital, m&eacute;dico e fornecedor de
OPME) e cobrados diretamente do Cliente, que dever&aacute; arcar com a
diferen&ccedil;a dos valores. </font></font></p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.8. 
Garantir o valor da proposta fora do prazo de 30 dias, sendo que,
caso o Cliente manifeste interesse na realiza&ccedil;&atilde;o do procedimento com
proposta vencida, esta poder&aacute; ter seus valores atualizados por parte dos
parceiros (Hospital, m&eacute;dico e fornecedor de OPME) e o Usu&aacute;rio cliente
receber&aacute; proposta atualizada. </font></font></p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.1.9.
Agendamento de Centro Cir&uacute;rgico e confirma&ccedil;&atilde;o da data do
procedimento junto aos Usu&aacute;rios Cliente e Fornecedor(es) de OPME,
sendo estes de responsabilidade do Usu&aacute;rio M&eacute;dico e/ou da equipe
m&eacute;dica. </font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">8.2.
Ainda, n&atilde;o nos responsabilizamos pelas condutas realizadas pelo Usu&aacute;rio
M&eacute;dico, Usu&aacute;rio Secret&aacute;ria, Usu&aacute;rio Hospital, Usu&aacute;rio OPME e Usu&aacute;rio Cliente,
dentro da plataforma. Qualquer dano causado a terceiros e a outros Usu&aacute;rios
ser&aacute; de responsabilidade do Usu&aacute;rio que realizou a conduta. A Syn se reserva o
direito de regresso.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>9.
REGRAS DE CONDUTA E PROIBI&Ccedil;&Otilde;ES</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.
Os Usu&aacute;rios</font><font face="Tahoma, serif"><b> </b></font><font face="Tahoma, serif"><u><b>n&atilde;o</b></u></font><font face="Tahoma, serif">&nbsp;podem:</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.1.
Lesar direitos da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">,
dos operadores da Plataforma, de outros Usu&aacute;rios, de terceiros
ou agir sob qualquer meio ou forma que possa contribuir com tal
viola&ccedil;&atilde;o;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.2.
Executar atos que limitem ou impe&ccedil;am a utiliza&ccedil;&atilde;o
da Plataforma ou acessar ilicitamente a </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.3.
Utilizar a ferramenta para praticar a&ccedil;&otilde;es il&iacute;citas,
como fraude, estelionato, apropria&ccedil;&atilde;o ind&eacute;bita,
enriquecimento il&iacute;cito, furto e roubo;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.4.
Difundir mensagens n&atilde;o relacionadas com a Plataforma ou com
suas finalidades, incluindo mensagens com conte&uacute;do impr&oacute;prio
ou que ofendam Usu&aacute;rios, a </font><font face="Tahoma, serif"><b>Syn
</b></font><font face="Tahoma, serif">ou terceiros;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.5.
Responsabilizar a </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">pela
indica&ccedil;&atilde;o de servi&ccedil;os que n&atilde;o estejam
vinculados a </font><font face="Tahoma, serif"><b>Syn;</b></font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.6.
Responsabilizar a </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">
por condutas de Usu&aacute;rios que estejam
cadastrados na Plataforma e cadastrar pessoas sem autoriza&ccedil;&atilde;o no
sistema;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.7.
Participar de qualquer atividade relacionada &agrave; </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">
que seja ilegal, danosa, ofensiva, obscena, violenta, amea&ccedil;adora,
coercitiva, abusiva ou de qualquer forma question&aacute;vel pela
</font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.8.
Reproduzir, duplicar, copiar ou revender qualquer parte do Sistema em
viola&ccedil;&atilde;o &agrave;s disposi&ccedil;&otilde;es deste
termo de uso;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.9.
Revender o acesso ao sistema;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.10.
Enquadrar o sistema ou qualquer parte dele;</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.11.
Copiar qualquer material obtido do Sistema para redes ponto a ponto
ou outros sites ou servi&ccedil;os da web;
</font></font>
</p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt">
<font face="Tahoma, serif">
9.1.12.
Acessar sem autoridade, interferir, danificar ou interromper qualquer
parte do sistema, qualquer equipamento ou rede na qual o sistema
esteja armazenado, qualquer software usado no fornecimento do sistema
ou qualquer equipamento ou rede ou software de propriedade ou usado
por terceiros.
</font></font>
</p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.13.
Criar plataforma similar ou que exer&ccedil;a qualquer forma de
concorr&ecirc;ncia direta com a</font><font face="Tahoma, serif"><b>
Syn</b></font><font face="Tahoma, serif">, podendo ser
responsabilizado civil ou criminalmente por eventuais danos materiais
ou morais.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">

</p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.14.
Concretizar neg&oacute;cios indicados pela </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">,
sem a participa&ccedil;&atilde;o desta, sob pena de responder pelos
danos causados e incorrer em uma multa n&atilde;o compensat&oacute;ria
no valor do or&ccedil;amento proposto.</font></font></p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1.15.
Receber qualquer quantia em nome da </font><font face="Tahoma, serif"><b>Syn</b></font><font color="#222222"><font face="Tahoma, serif">,</font></font><font face="Tahoma, serif">
salvo defini&ccedil;&atilde;o em conjunto entre as Partes, bem como
ret&ecirc;-la a qualquer t&iacute;tulo, sob pena de, ap&oacute;s ser
constitu&iacute;do em mora e demonstrado o dolo do </font><font face="Tahoma, serif"><b>PARCEIRO</b></font><font face="Tahoma, serif">,
passar o ato a configurar apropria&ccedil;&atilde;o ind&eacute;bita,
conforme previs&atilde;o inserta no C&oacute;digo Penal Brasileiro.</font></font></p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.2.A Syn poder&aacute;, a seu exclusivo crit&eacute;rio, bloquear, restringir, desabilitar ou
impedir o acesso de qualquer Usu&aacute;rio &agrave; plataforma sempre que for detectada
uma conduta inadequada, sem necessidade de aviso pr&eacute;vio ou direito a qualquer
tipo de compensa&ccedil;&atilde;o.</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.3.
O Usu&aacute;rio Cliente poder&aacute; denunciar condutas il&iacute;citas por parte dos demais
Usu&aacute;rios, venda de produtos ou servi&ccedil;os il&iacute;citos e proibidos por meio dos canais
de contato descritos na cl&aacute;usula 16 destes Termos. </font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>10.
PROPRIEDADE INTELECTUAL</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">10.1.
A titularidade e os direitos relativos &agrave; plataforma pertencem exclusivamente
&agrave; <b>SYN SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE LTDA</b>. O acesso &agrave; plataforma e a sua regular
utiliza&ccedil;&atilde;o pelo Usu&aacute;rio n&atilde;o lhe conferem qualquer direito ou prerrogativa sobre
propriedade intelectual ou outro conte&uacute;do nela inserido.</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">10.2.Todo o conte&uacute;do da plataforma, incluindo nome, marca, dom&iacute;nio,
programas, bases de dados, arquivos, textos, desenhos, fotos, layouts,
cabe&ccedil;alhos e demais elementos, foi criado, desenvolvido e cedido a <b>SYN
SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE LTDA</b>, sendo, portanto, de propriedade exclusiva da<b>
SYN SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE LTDA </b> ou a ela licenciado e encontra-se protegido
pelas leis brasileiras e tratados internacionais que versam sobre direitos de
propriedade intelectual.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">10.3.
S&atilde;o proibidas: a explora&ccedil;&atilde;o, cess&atilde;o,
imita&ccedil;&atilde;o, c&oacute;pia, pl&aacute;gio, aplica&ccedil;&atilde;o
de engenharia reversa, tentativa de invas&atilde;o (hackear),
armazenamento, altera&ccedil;&atilde;o, modifica&ccedil;&atilde;o de
caracter&iacute;sticas, amplia&ccedil;&atilde;o, venda, loca&ccedil;&atilde;o,
doa&ccedil;&atilde;o, aliena&ccedil;&atilde;o, transfer&ecirc;ncia,
reprodu&ccedil;&atilde;o, integral ou parcial, de qualquer conte&uacute;do
da Plataforma da </font><font face="Tahoma, serif"><b>SYN
SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE LTDA</b></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">10.4.
A pessoa que violar as proibi&ccedil;&otilde;es contidas na
legisla&ccedil;&atilde;o sobre propriedade intelectual e nestes
Termos ser&aacute; responsabilizada, civil e criminalmente, pelas
infra&ccedil;&otilde;es cometidas, al&eacute;m de poder ser
penalizado na Plataforma.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>11.
SIGILO E CONFIDENCIALIDADE</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">11.1.
  Os Usu&aacute;rios comprometem-se a manter o mais absoluto sigilo
de todas as informa&ccedil;&otilde;es de conte&uacute;do
confidencial, sejam elas comerciais, t&eacute;cnicas, pessoais e
outras, cujo conhecimento tiver, em decorr&ecirc;ncia do exerc&iacute;cio
de suas atividades na plataforma, podendo ser responsabilizado civil
ou criminalmente por eventuais danos materiais ou morais decorrentes
da n&atilde;o obedi&ecirc;ncia a esta regra.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">11.2.
  Por defini&ccedil;&atilde;o, &ldquo;Informa&ccedil;&otilde;es
Confidenciais&rdquo; significam todos as informa&ccedil;&otilde;es
t&eacute;cnicas e gerais, know-how, documentos, programas de
computador e documenta&ccedil;&atilde;o, c&oacute;digos fonte,
estrat&eacute;gias de Growth, modelo de neg&oacute;cio, relat&oacute;rios,
dados financeiros, dados pessoais, registros, formul&aacute;rios,
ferramentas, produtos, servi&ccedil;os, pesquisa presente e futura,
conhecimento t&eacute;cnico, planos de marketing, segredos comerciais
e outros materiais tang&iacute;veis ou intang&iacute;veis,
armazenados ou n&atilde;o, compilados ou reduzidos a termo, seja
f&iacute;sica, eletr&ocirc;nica ou graficamente, por escrito, ou por
qualquer meio, que esteja em poder da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">
ou referentes a seus Usu&aacute;rios, que seja revelado ao Usu&aacute;rio.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">11.3.
  As Informa&ccedil;&otilde;es Confidenciais incluem, sem limita&ccedil;&atilde;o,
materiais, arquivos e informa&ccedil;&otilde;es, bem como as
informa&ccedil;&otilde;es de propriedade da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">
ou de terceiros que: a) contenha a especifica&ccedil;&atilde;o de
propriedade exclusiva ou confidencial; b) cuja natureza confidencial
tenha sido informada ao Usu&aacute;rio; c) consistam na solu&ccedil;&atilde;o,
nas inova&ccedil;&otilde;es e aperfei&ccedil;oamentos que sejam de
cria&ccedil;&atilde;o e desenvolvimento individual da </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif">
ou em conjunto entre as Partes; d) em virtude de suas caracter&iacute;sticas
e natureza seriam consideradas confidenciais em circunst&acirc;ncias
semelhantes; e, e) dados de natureza sens&iacute;vel.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">11.4.
O Usu&aacute;rio concorda que as obriga&ccedil;&otilde;es de
Confidencialidade e Sigilo se iniciam a partir do aceite dos termos
de uso e do cadastro na Plataforma, perdurando na sua vig&ecirc;ncia
e por </font><font face="Tahoma, serif">03 (tr&ecirc;s) a</font><font face="Tahoma, serif">nos
ap&oacute;s o &uacute;ltimo per&iacute;odo de utiliza&ccedil;&atilde;o
e acesso na Plataforma pelo Usu&aacute;rio. Desta forma e na hip&oacute;tese
de viola&ccedil;&atilde;o, a </font><font face="Tahoma, serif"><b>Syn
</b></font><font face="Tahoma, serif">ser&aacute; imediatamente
considerada leg&iacute;tima detentora do direito a tomar todas as
medidas extrajudiciais e judiciais, nas esferas c&iacute;veis e
criminais, inclusive de car&aacute;ter cautelar ou de antecipa&ccedil;&atilde;o
de tutela jurisdicional, que julgar cab&iacute;veis &agrave; defesa
de seus direitos, inclusive autorais, independentemente da tomada das
medidas judiciais tendentes a obter a repara&ccedil;&atilde;o pelo
dano causado, o que inclui, caso aplic&aacute;vel, a indeniza&ccedil;&atilde;o
de lucros cessantes.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>12.
TRATAMENTO DE DADOS PESSOAIS, PRIVACIDADE E SEGURAN&Ccedil;A</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">12.1.
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">disp&otilde;e
de uma pol&iacute;tica espec&iacute;fica para regular a coleta,
guarda e tratamento de dados pessoais, bem como a sua seguran&ccedil;a:
Pol&iacute;ticas de Privacidade. Essas pol&iacute;ticas espec&iacute;ficas
integram inseparavelmente estes Termos, ressaltando-se que os dados
de utiliza&ccedil;&atilde;o da Plataforma ser&atilde;o arquivados nos
termos da legisla&ccedil;&atilde;o em vigor.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>13.
DESDOBRAMENTOS DO ACESSO &Agrave; PLATAFORMA</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">13.1.
Apesar dos melhores esfor&ccedil;os da </font><font face="Tahoma, serif"><b>Syn
</b></font><font face="Tahoma, serif">para fornecer as melhores
tecnologias para manter a conex&atilde;o e sincroniza&ccedil;&atilde;o
online e acesso seguro aos Usu&aacute;rios, em virtude de
dificuldades t&eacute;cnicas, aplica&ccedil;&otilde;es de internet ou
problemas de transmiss&atilde;o, &eacute; poss&iacute;vel ocorrer
c&oacute;pias inexatas ou incompletas das informa&ccedil;&otilde;es
contidas na Plataforma. Al&eacute;m disso, v&iacute;rus de computador
ou outros programas danosos tamb&eacute;m poder&atilde;o ser baixados
inadvertidamente da Plataforma.</font></font></p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">13.1.1.
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">recomenda
a instala&ccedil;&atilde;o de antiv&iacute;rus ou protetores
adequados.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">13.2.
A </font><font face="Tahoma, serif"><b>Syn</b></font><font face="Tahoma, serif"><b>
</b></font><font face="Tahoma, serif">se reserva o direito de
unilateralmente modificar a Plataforma, bem como a configura&ccedil;&atilde;o,
a apresenta&ccedil;&atilde;o, o desenho, o conte&uacute;do, as
funcionalidades, as ferramentas ou qualquer outro elemento, inclusive
o seu cancelamento.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">13.3.
A plataforma SYN pode conter links de sites/plataformas de terceiros. Ao
seguir um link, o Usu&aacute;rio deve verificar as pol&iacute;ticas de privacidade desses
sites/plataformas, pois n&atilde;o aceitamos qualquer responsabilidade ou obriga&ccedil;&atilde;o
por essas pol&iacute;ticas. Por favor, verifique essas pol&iacute;ticas antes de compartilhar
quaisquer dados pessoais com esses sites.</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>14.
ALTERA&Ccedil;&Otilde;ES DOS TERMOS E CONDI&Ccedil;&Otilde;ES DE USO</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">14.1.
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">poder&aacute;
unilateralmente adicionar e/ou modificar qualquer cl&aacute;usula
contida nestes Termos de Uso. A vers&atilde;o atualizada valer&aacute;
para o uso da Plataforma realizada a partir de sua publica&ccedil;&atilde;o.
A continuidade de acesso ou utiliza&ccedil;&atilde;o da Plataforma,
depois da divulga&ccedil;&atilde;o, confirmar&aacute; a vig&ecirc;ncia
dos novos Termos de Uso pelos Usu&aacute;rios.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">14.2.
Caso a mudan&ccedil;a efetuada necessite de consentimento do Usu&aacute;rio,
ser&aacute; apresentada a op&ccedil;&atilde;o de aceitar de forma
livre, inequ&iacute;voca e informada o novo texto ou recus&aacute;-lo.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; page-break-before: always">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">14.3.
Caso o Usu&aacute;rio n&atilde;o esteja de acordo com a altera&ccedil;&atilde;o,
poder&aacute; n&atilde;o fornecer consentimento para atos espec&iacute;ficos
ou poder&aacute; rescindir totalmente seu v&iacute;nculo com a </font><font face="Tahoma, serif"><b>Syn.</b></font><font face="Tahoma, serif">
Essa rescis&atilde;o n&atilde;o eximir&aacute;, no entanto, o Usu&aacute;rio
de cumprir com todas as obriga&ccedil;&otilde;es assumidas sob as
vers&otilde;es precedentes dos Termos de Uso.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
</font><font face="Tahoma, serif"><u><b>15.
LEI APLIC&Aacute;VEL E FORO DE ELEI&Ccedil;&Atilde;O</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">15.1.
A plataforma &eacute; controlada e administrada na cidade de S&atilde;o Lu&iacute;s, Estado do
Maranh&atilde;o, Brasil, podendo ser acessada por qualquer dispositivo conectado &agrave;
Internet, independentemente de sua localiza&ccedil;&atilde;o geogr&aacute;fica.</font></font></p>
<p align="justify" style="margin-left: 1.5cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">15.1.1.
As pessoas que acessam ou usam a Syn a partir de outros pa&iacute;ses
o fazem por conta pr&oacute;pria e s&atilde;o respons&aacute;veis pelo cumprimento das leis
regionais/nacionais.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">15.2.
O Usu&aacute;rio concorda que a legisla&ccedil;&atilde;o aplic&aacute;vel
para fins destes Termos e Condi&ccedil;&otilde;es de Uso e das
Pol&iacute;ticas de Privacidade ser&aacute; a vigente na Rep&uacute;blica
Federativa do Brasil.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">15.3.
A </font><font face="Tahoma, serif"><b>Syn </b></font><font face="Tahoma, serif">e
o Usu&aacute;rio concordam que o Foro de S&atilde;o Lu&iacute;s/MA,
Brasil, ser&aacute; o &uacute;nico competente para dirimir qualquer
quest&atilde;o ou controv&eacute;rsia oriunda ou resultante do uso da
Plataforma, renunciando expressamente a qualquer outro, por mais
privilegiado que seja, ou venha a ser.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>16.
CONTATO</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%"><a name="_heading=h.2et92p0"></a>
<font face="Tahoma, serif"><font size="3" style="font-size: 12pt">16.1.
A </font></font><font face="Tahoma, serif"><font size="3" style="font-size: 12pt"><b>Syn</b></font></font><font face="Tahoma, serif"><font size="3" style="font-size: 12pt"><b>
</b></font></font><font face="Tahoma, serif"><font size="3" style="font-size: 12pt">disponibiliza
o seguinte e-mail para receber todas as comunica&ccedil;&otilde;es
que os Usu&aacute;rios desejarem fazer: </font></font><font color="#0000ff"><u><a href="mailto:contato@synsaude.com.br"><font face="Tahoma, serif"><font size="3" style="font-size: 12pt">contato@synsaude.com.br</font></font></a></u></font><font face="Tahoma, serif"><font size="3" style="font-size: 12pt">.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<br/>
<br/>

</p>
<p align="center" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Esta
Plataforma pertence &agrave; SYN SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE
LTDA, CNPJ/ME n&ordm; 38.312.622/0001-28.</font></font></p>
</body>
</html>
`
